import { Injectable } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { AppSettings } from '../Library/AppSettings';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService extends BaseService {
    URL_Analytics_Glitch: any;
    URL_Analytics_HK: any;
    URL_Analytics_Service: any;
    constructor(
        public apiService: APIServiceConnector
    ) {
        super();
        this.URL_Analytics_Glitch = AppSettings.URL_Analytics_Glitch;
        this.URL_Analytics_HK = AppSettings.URL_Analytics_HK;
        this.URL_Analytics_Service = AppSettings.URL_Analytics_Service;
    }
    analyticsServiceURL : string = "";
    analyticsGlitchURL: string = "";
    analyticsHKURL: string = "";
    inprogress : boolean = false;

    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async fetchAnalyticsURL(module = 'service', trackLoading = false) {
        if (module == 'service') {
            if (this.analyticsServiceURL) return this.analyticsServiceURL
        } else if (module == 'glitch') {
            if (this.analyticsGlitchURL) return this.analyticsGlitchURL
        } else {
            if (this.analyticsHKURL) return this.analyticsHKURL
        }
        if(this.inprogress){
            await this.timeout(1000);
            return await this.fetchAnalyticsURL(module,trackLoading)
        }else{
            this.inprogress = true
            let baseURL = (module == 'service') ? this.URL_Analytics_Service : ((module == 'glitch') ? this.URL_Analytics_Glitch : this.URL_Analytics_HK);
            if (module == 'service') {
                if (this.analyticsServiceURL) return this.analyticsServiceURL
            } else if (module == 'glitch') {
                if (this.analyticsGlitchURL) return this.analyticsGlitchURL
            } else {
                if (this.analyticsHKURL) return this.analyticsHKURL
            }
            return this.apiService
                .getAPI(baseURL, '', trackLoading)
                .then((data: any) => {
                    if (module == 'service') {
                        this.analyticsServiceURL = (data && data.url) ? data.url : '';
                    } else if (module == 'glitch') {
                        this.analyticsGlitchURL = (data && data.url) ? data.url : '';
                    } else {
                        this.analyticsHKURL = (data && data.url) ? data.url : '';
                    }
                    this.inprogress = false;
                    return (data && data.url) ? data.url : '';
                }).catch((e) => {
                    console.log("Error in fetching URLS",e)
                    this.inprogress = false;
                    return "";
                })
        }
    }
}
